<template>
  <div v-loading="loading">
    <div id="wrap" class="fixed">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="企业信息" name="first"></el-tab-pane>
        <el-tab-pane label="经济效益" name="second"></el-tab-pane>
        <el-tab-pane label="专业化程度" name="third"></el-tab-pane>
        <el-tab-pane label="创新能力" name="fourth"></el-tab-pane>
        <el-tab-pane label="经营管理" name="six"></el-tab-pane>
        <el-tab-pane label="资料生成" name="seven"></el-tab-pane>
      </el-tabs>
    </div>
    <br />
    <div id="wrap2" class="wrap_page" style="margin-top:70px;">
      <div class="text">基本信息</div>
      <el-form
        class="ruleForm flex flex-wrap"
        :model="param"
        :rules="rules"
        ref="ruleForm1"
        label-position="top"
      >
        <el-form-item prop="zjtxProjectBO.companyName" class="item">
          <span slot="label">
            <span class="span-box">
              <span>公司名称</span>
            </span>
          </span>
          <el-input disabled v-model="param.zjtxProjectBO.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.unifySocialCreditCode" class="item">
          <span slot="label">
            <span class="span-box">
              <span>统一社会信用代码</span>
            </span>
          </span>
          <el-input
            disabled
            v-model="param.zjtxProjectBO.unifySocialCreditCode"
            placeholder="请输入统一社会信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.legalPerson" class="item">
          <span slot="label">
            <span class="span-box">
              <span>法人</span>
            </span>
          </span>
          <el-input disabled v-model="param.zjtxProjectBO.legalPerson" placeholder="请输入法人"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.registeredCapital" class="item">
          <span slot="label">
            <span class="span-box">
              <span>注册资金</span>
            </span>
          </span>
          <el-input disabled v-model="param.zjtxProjectBO.registeredCapital" placeholder="请输入注册资金"></el-input>
        </el-form-item>

        <el-form-item prop="zjtxProjectBO.registeredTime" class="item">
          <span slot="label">
            <span class="span-box">
              <span>注册日期</span>
            </span>
          </span>

          <el-input disabled v-model="param.zjtxProjectBO.registeredTime"></el-input>
        </el-form-item>

        <el-form-item prop="zjtxProjectBO.registeredType" class="item">
          <span slot="label">
            <span class="span-box">
              <span>注册类型</span>
            </span>
          </span>
          <el-input disabled v-model="param.zjtxProjectBO.registeredType" placeholder="请输入注册类型"></el-input>
        </el-form-item>

        <el-form-item prop="zjtxProjectBO.industry" class="item">
          <span slot="label">
            <span class="span-box">
              <span>所属行业</span>
            </span>
          </span>
          <el-input disabled v-model="param.zjtxProjectBO.industry" placeholder="请输入所属行业"></el-input>
        </el-form-item>

        <el-form-item label="所属区域" label-width="23%" :required="true" class="item">
          <span slot="label">
            <span class="span-box">
              <span>所属区域</span>
            </span>
          </span>
          <div class="select_box" style="display: flex">
            <el-form-item prop="zjtxProjectBO.province">
              <el-select
                v-model="param.zjtxProjectBO.province"
                placeholder="省"
                @change="provinceCchange"
              >
                <el-option
                  v-for="dict in province"
                  :key="dict.id"
                  :label="dict.districtName"
                  :value="dict.districtKey"
                  placeholder="请选择"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="zjtxProjectBO.city">
              <el-select v-model="param.zjtxProjectBO.city" placeholder="市" @change="cityCchange">
                <el-option
                  v-for="dict in city"
                  :key="dict.id"
                  :label="dict.districtName"
                  :value="dict.districtKey"
                  placeholder="请选择"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="zjtxProjectBO.countie">
              <el-select v-model="param.zjtxProjectBO.countie" placeholder="区">
                <el-option
                  v-for="dict in counties"
                  :key="dict.id"
                  :label="dict.districtName"
                  :value="dict.districtKey"
                  placeholder="请选择"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>

        <el-form-item label="企业规模" prop="zjtxProjectBO.companyScale" label-width="50%" class="item">
          <span slot="label">
            <span class="span-box">
              <span>企业规模</span>
            </span>
          </span>
          <el-select v-model="param.zjtxProjectBO.companyScale">
            <el-option
              v-for="dict in enterpriseScale"
              :key="dict.id"
              :label="dict.dictName"
              :value="dict.dictCode"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="zjtxProjectBO.address" class="item">
          <span slot="label">
            <span class="span-box">
              <span>通信地址</span>
            </span>
          </span>
          <el-input v-model="param.zjtxProjectBO.address" placeholder="请输入通信地址"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.postalCode" class="item">
          <span slot="label">
            <span class="span-box">
              <span>邮政编码</span>
            </span>
          </span>
          <el-input
            type="number"
            min="0"
            v-model="param.zjtxProjectBO.postalCode"
            placeholder="请输入邮政编码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.employeeNumber" class="item">
          <span slot="label">
            <span class="span-box">
              <span>企业从业人员数</span>
            </span>
          </span>
          <el-input
            :min="0"
            type="number"
            v-model="param.zjtxProjectBO.employeeNumber"
            placeholder="企业从业人员数"
          ></el-input>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.employeeRdNumber" class="item">
          <span slot="label">
            <span class="span-box">
              <span>企业研发人员数</span>
            </span>
          </span>
          <el-input
            :min="0"
            type="number"
            v-model="param.zjtxProjectBO.employeeRdNumber"
            placeholder="企业研发人员数"
          ></el-input>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.companyType" class="item">
          <span slot="label">
            <span class="span-box">
              <span>企业类型</span>
            </span>
          </span>
          <el-select v-model="param.zjtxProjectBO.companyType">
            <el-option
              v-for="dict in companyTypes"
              :key="dict.id"
              :label="dict.dictName"
              :value="dict.dictCode"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item prop="zjtxProjectBO.zjtxType" class="item">
          <span slot="label">
            <span class="span-box">

              <span>专精特新类型</span>
            </span>
          </span>
          <el-input
            v-model="param.zjtxProjectBO.zjtxType"
            placeholder=""
          ></el-input>
        </el-form-item>-->
      </el-form>
    </div>

    <div id="wrap3" class="wrap_page">
      <div class="text">企业法人信息</div>
      <el-form
        class="ruleForm flex flex-wrap"
        :rules="rules"
        :model="param"
        ref="ruleForm2"
        label-position="top"
      >
        <el-form-item prop="zjtxLegalPerson.linkmanName" class="item">
          <span slot="label">
            <span class="span-box">
              <!--              -->
              <span>姓名</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLegalPerson.linkmanName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxLegalPerson.phone" class="item">
          <span slot="label">
            <span class="span-box">
              <span>电话</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLegalPerson.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxLegalPerson.mobile" class="item">
          <span slot="label">
            <span class="span-box">
              <span>手机</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLegalPerson.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div id="wrap4" class="wrap_page">
      <div class="text">联系人信息</div>
      <el-form
        class="ruleForm flex flex-wrap"
        :rules="rules"
        :model="param"
        ref="ruleForm3"
        label-position="top"
      >
        <el-form-item prop="zjtxLinkmanBO.linkmanName" class="item">
          <span slot="label">
            <span class="span-box">
              <!--              -->
              <span>姓名</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLinkmanBO.linkmanName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxLinkmanBO.phone" class="item">
          <span slot="label">
            <span class="span-box">
              <span>电话</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLinkmanBO.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxLinkmanBO.mobile" class="item">
          <span slot="label">
            <span class="span-box">
              <span>手机</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLinkmanBO.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxLinkmanBO.fax" class="item">
          <span slot="label">
            <span class="span-box">
              <span>传真</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLinkmanBO.fax" placeholder="请输入传真"></el-input>
        </el-form-item>
        <el-form-item prop="zjtxLinkmanBO.email" class="item">
          <span slot="label">
            <span class="span-box">
              <span>EMAIL</span>
            </span>
          </span>
          <el-input v-model="param.zjtxLinkmanBO.email" placeholder="请输入EMAIL"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div id="wrap5" class="wrap_page">
      <div class="text">上市信息</div>
      <el-form
        class="ruleForm flex flex-wrap"
        :model="param"
        :rules="rules"
        ref="ruleForm4"
        label-position="top"
      >
        <el-form-item prop="zjtxListedInformationBO.isListed" class="item">
          <span slot="label">
            <span class="span-box">
              <span>企业是否上市</span>
            </span>
          </span>
          <el-select
            v-model="param.zjtxListedInformationBO.isListed"
            placeholder="请选择"
            @change="shangshi"
          >
            <el-option
              v-for="dict in enterpriseIsMarket"
              :key="dict.id"
              :label="dict.dictName"
              :value="dict.dictCode"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="zjtxListedInformationBO.listedType" class="item" v-show="isshow1">
          <span slot="label">
            <span class="span-box">
              <!--              -->
              <span>上市类型</span>
            </span>
          </span>
          <el-select v-model="param.zjtxListedInformationBO.listedType" placeholder="请选择">
            <el-option
              v-for="item in listedType"
              :key="item.id"
              :label="item.dictName"
              :value="item.dictCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="zjtxListedInformationBO.listedProcess" class="item" v-show="isshow2">
          <span slot="label">
            <span class="span-box">
              <!--              -->
              <span>上市进程</span>
            </span>
          </span>
          <el-select v-model="param.zjtxListedInformationBO.listedProcess" placeholder="请选择">
            <el-option
              v-for="item in listedProcess"
              :key="item.id"
              :label="item.dictName"
              :value="item.dictCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="zjtxListedInformationBO.stockCode" class="item" v-show="isshow3">
          <span slot="label">
            <span class="span-box">
              <!--              -->
              <span>股票代码</span>
            </span>
          </span>
          <el-input v-model="param.zjtxListedInformationBO.stockCode" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div id="wrap" class="wrap_page">
      <div class="text" style="margin-bottom: 15px">技术领域</div>
      <el-form class="ruleForm flex flex-wrap" ref="ruleForm5" label-position="top">
        <el-form-item prop="zjtxProjectBO.tecFieldFirst" class="item selects">
          <el-select
            v-model="param.zjtxProjectBO.tecFieldFirst"
            placeholder="选择"
            @change="tecFieldCchange"
          >
            <el-option
              v-for="dict in tecFieldFirst"
              :key="dict.id"
              :label="dict.dictName"
              :value="dict.dictCode"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="zjtxProjectBO.tecFieldSecond" class="item selects">
          <el-select v-model="param.zjtxProjectBO.tecFieldSecond" @change="tecFieldSecondCchange">
            <el-option
              v-for="dict in tecFieldSecond"
              :key="dict.id"
              :label="dict.dictName"
              :value="dict.dictCode"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="zjtxProjectBO.tecFieldThird" class="item selects">
          <el-select v-model="param.zjtxProjectBO.tecFieldThird">
            <el-option
              v-for="dict in tecFieldThird"
              :key="dict.id"
              :label="dict.dictName"
              :value="dict.dictCode"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="flex flex-center" style="margin-top: 20px">
      <el-button type="primary" @click="save()">保存</el-button>
      <el-button type="primary" @click="resetData()">重置</el-button>
      <el-button type="primary" @click="nextPage()">下一项</el-button>
    </div>
  </div>
</template>

<script>
import {
  add_essential,
  queryBaseInfo,
  update_essential,
} from '@/api/specialization'
import {
  getDict,
  queryDictDataByTypeAndCode,
  getDistrictByParentId,
  getDistrictByKey,
  enterpriseInformationRegisterQuery,
  enterpriseInformationRegisterSave,
} from '@/api/ChinaHigh'
import { commonGetCompanyInfo } from '@/api/toolCommon'

export default {
  data() {
    return {
      isshow1: true,
      isshow2: true,
      isshow3: true,

      rules: {
        'zjtxProjectBO.companyName': [
          { required: true, message: '请填写公司名称', trigger: 'blur' },
        ],
        'zjtxLinkmanBO.linkmanName': [
          { required: true, message: '请填写联系人名称', trigger: 'change' },
        ],
        'zjtxLegalPerson.linkmanName': [
          { required: true, message: '请填写法人名称', trigger: 'change' },
        ],
        'zjtxProjectBO.unifySocialCreditCode': [
          {
            required: true,
            message: '请填写统一社会信用代码',
            trigger: 'blur',
          },
        ],
        'zjtxProjectBO.legalPerson': [
          { required: true, message: '请填写法人名称', trigger: 'blur' },
        ],
        'zjtxProjectBO.registeredCapital': [
          { required: true, message: '请填写注册资金', trigger: 'blur' },
        ],
        'zjtxProjectBO.registeredTime': [
          { required: true, message: '请填写注册日期', trigger: 'blur' },
        ],
        // "zjtxProjectBO.registeredType":[{required:true,message:"请填写注册类型",trigger:"change"}],
        'zjtxProjectBO.industry': [
          { required: true, message: '请填写所属行业', trigger: 'blur' },
        ],
        'zjtxProjectBO.province': [
          { required: true, message: '请选择省份', trigger: 'change' },
        ],
        'zjtxProjectBO.city': [
          { required: true, message: '请选择市', trigger: 'change' },
        ],
        'zjtxProjectBO.countie': [
          { required: true, message: '请选择区域', trigger: 'change' },
        ],
        'zjtxProjectBO.companyScale': [
          { required: true, message: '请选择规模', trigger: 'change' },
        ],
        'zjtxProjectBO.address': [
          { required: true, message: '请填写通信地址', trigger: 'change' },
        ],
        'zjtxProjectBO.zjtxType': [
          { required: true, message: '请填写类型', trigger: 'blur' },
        ],
        'zjtxProjectBO.postalCode': [
          { required: true, message: '请填写邮政编码', trigger: 'change' },
        ],
        'zjtxProjectBO.employeeNumber': [
          {
            required: true,
            message: '请填写企业从业人员数',
            trigger: 'change',
          },
        ],
        'zjtxProjectBO.employeeRdNumber': [
          {
            required: true,
            message: '请填写企业研发人员数',
            trigger: 'change',
          },
        ],
        'zjtxProjectBO.companyType': [
          { required: true, message: '请选择企业类型', trigger: 'change' },
        ],
        'zjtxLegalPerson.mobile': [
          { required: true, message: '请输入手机', trigger: 'change' },
          {
            pattern:
              /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|17[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/,
            message: '请输入正确的手机号码',
            trigger: 'change',
          },
        ],
        'zjtxLegalPerson.phone': [
          { required: true, message: '请填写电话', trigger: 'change' },
          {
            pattern: /^0\d{2,3}-?\d{7,8}$/,
            message: '请输入正确的电话号码',
            trigger: 'blur',
          },
        ],
        'zjtxLinkmanBO.mobile': [
          { required: true, message: '请输入手机', trigger: 'change' },
          {
            pattern:
              /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|17[012356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/,
            message: '请输入正确的手机号码',
            trigger: 'change',
          },
        ],
        'zjtxLinkmanBO.phone': [
          { required: true, message: '请填写电话', trigger: 'change' },
          {
            pattern: /^0\d{2,3}-?\d{7,8}$/,
            message: '请输入正确的电话号码',
            trigger: 'change',
          },
        ],
        'zjtxLinkmanBO.fax': [
          { required: true, message: '请填写传真', trigger: 'change' },
          {
            pattern: /^(?:\d{3,4}-)?\d{7,8}(?:-\d{1,6})?$/,
            message: '请输入正确的传真',
            trigger: 'change',
          },
        ],
        'zjtxLinkmanBO.email': [
          { required: true, message: '请输入EMALL', trigger: 'change' },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: '请输入正确的EMAIL',
            trigger: 'change',
          },
        ],
        'zjtxListedInformationBO.isListed': [
          { required: true, message: '请选择是否上市', trigger: 'change' },
        ],
      },
      activeName: 'first',
      companyTypes: [],
      //省
      province: {},
      //市
      city: {},
      //区
      counties: {},
      //企业规模
      enterpriseScale: {},
      param: {
        // 基本信息
        zjtxProjectBO: {
          id: '',
          companyName: '',
          unifySocialCreditCode: '',
          legalPerson: '',
          registeredCapital: '',
          registeredTime: '',
          registeredType: '',
          industry: '',
          companyScale: '',
          address: '',
          postalCode: '',
          zjtxType: '国家专精特新小巨人',
        },
        // 法人
        zjtxLegalPerson: {
          id: '',
          linkmanName: '',
          mobile: '',
          phone: '',
          isLegalPerson: 1,
        },
        // 联系人
        zjtxLinkmanBO: {
          id: '',
          linkmanName: '',
          mobile: '',
          phone: '',
          fax: '',
          email: '',
          isLegalPerson: 2,
        },
        // 上市信息
        zjtxListedInformationBO: {
          id: '',
          stockCode: '',
        },
      },
      //上市类型
      listedType: {},
      //上市进程
      listedProcess: {},
      //是否上市
      enterpriseIsMarket: {},
      //技术领域一级
      tecFieldFirst: {},
      //技术领域二级
      tecFieldSecond: {},
      //技术领域三级
      tecFieldThird: {},
      loading: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    shangshi(e) {
      // console.log(e);
      if (e == 1) {
        this.isshow1 = true
        this.isshow2 = false
          this.param.zjtxListedInformationBO.listedProcess='';
      }else if(e == 2){
          this.isshow1 = false;
          this.isshow2 = true;
          this.isshow3 = false;
          this.param.zjtxListedInformationBO.listedType='';
          this.param.zjtxListedInformationBO.stockCode='';
      }else if(e == 3) {
          this.isshow1 = false;
          this.isshow2 = false;
          this.isshow3 = false;
          this.param.zjtxListedInformationBO.listedType = '';
          this.param.zjtxListedInformationBO.listedProcess = '';
          this.param.zjtxListedInformationBO.stockCode = '';
      }
    },
    nextPage() {
      if (sessionStorage.getItem('zt_special_id') != '0') {
        this.$router.push('/centerform/specializationBenefit')
      } else {
        this.msgError('请先保存企业信息,保存后才可继续操作')
      }
    },
    resetData() {
      this.msgSuccess('重置')
      console.log(this.param.zjtxProjectBO.postalCode)
      this.param.zjtxProjectBO.province = ''
      this.param.zjtxProjectBO.city = ''
      this.param.zjtxProjectBO.countie = ''
      this.param.zjtxProjectBO.companyScale = ''
      this.param.zjtxProjectBO.address = ''
      this.param.zjtxProjectBO.postalCode = ''
      this.param.zjtxProjectBO.employeeNumber = ''
      this.param.zjtxProjectBO.employeeRdNumber = ''
      this.param.zjtxProjectBO.companyType = ''
      this.param.zjtxProjectBO.tecFieldFirst = "";
      this.param.zjtxProjectBO.tecFieldThird = "";
      this.param.zjtxProjectBO.tecFieldSecond = "";
      this.param.zjtxLinkmanBO = { id: this.param.zjtxLinkmanBO.id }
      this.param.zjtxLegalPerson = { id: this.param.zjtxLegalPerson.id }
      this.param.zjtxListedInformationBO = {
        id: this.param.zjtxListedInformationBO.id,
      }
    },
    queryInfo(id) {
      id = sessionStorage.getItem('zt_special_id')
      this.loading = true
      queryBaseInfo(id).then((res) => {
        this.loading = false
        if (res.code == '00000') {
          // this.param.zjtxProjectBO = res.data.zjtxProjectBO;
          // this.param.zjtxListedInformationBO = res.data.zjtxListedInformationBO;
          // let linkmanList = res.data.zjtxLinkmanBO;
          // for (let i = 0; i < linkmanList.length; i++) {
          // 	if (linkmanList[i].isLegalPerson == 1) {
          // 		this.param.zjtxLegalPerson = linkmanList[i];
          // 	} else if (linkmanList[i].isLegalPerson == 2) {
          // 		this.param.zjtxLinkmanBO = linkmanList[i];
          // 	}
          if (res.data.zjtxProjectBO) {
            this.param.zjtxProjectBO = res.data.zjtxProjectBO
            this.param.zjtxListedInformationBO =
              res.data.zjtxListedInformationBO
            let linkmanList = res.data.zjtxLinkmanBO
            for (let i = 0; i < linkmanList.length; i++) {
              if (linkmanList[i].isLegalPerson == 1) {
                this.param.zjtxLegalPerson = linkmanList[i]
              } else if (linkmanList[i].isLegalPerson == 2) {
                this.param.zjtxLinkmanBO = linkmanList[i]
              }
            }
            if (
              res.data.zjtxProjectBO.tecFieldFirst !== '' &&
              res.data.zjtxProjectBO.tecFieldFirst !== null
            ) {
              this.jishu(res.data.zjtxProjectBO.tecFieldFirst, 1, 2)
            }
            if (
              res.data.zjtxProjectBO.tecFieldSecond !== '' &&
              res.data.zjtxProjectBO.tecFieldSecond !== null
            ) {
              this.jishu(res.data.zjtxProjectBO.tecFieldSecond, 2, 2)
            }
            if (
              res.data.zjtxProjectBO.province !== '' &&
              res.data.zjtxProjectBO.province !== null
            ) {
              this.quyu(res.data.zjtxProjectBO.province, 1, 2)
            }
            if (
              res.data.zjtxProjectBO.city !== '' &&
              res.data.zjtxProjectBO.city !== null
            ) {
              this.quyu(res.data.zjtxProjectBO.city, 2, 2)
            }
            this.param.zjtxProjectBO.zjtxType = '国家专精特新小巨人'
            if (this.param.zjtxListedInformationBO.isListed == 1) {
              this.isshow1 = true
              this.isshow2 = false
              this.isshow3 = true
            } else if (this.param.zjtxListedInformationBO.isListed == 2) {
              this.isshow1 = false
              this.isshow2 = true
              this.isshow3 = false
            } else if (this.param.zjtxListedInformationBO.isListed == 3) {
              this.isshow1 = false
              this.isshow2 = false
              this.isshow3 = false
            }
          } else {
            this.qy()
          }
          // if (
          // 	res.data.zjtxProjectBO.tecFieldFirst !== "" &&
          // 	res.data.zjtxProjectBO.tecFieldFirst !== null
          // ) {
          // 	this.jishu(res.data.zjtxProjectBO.tecFieldFirst, 1, 2);
          // }
          // if (
          // 	res.data.zjtxProjectBO.tecFieldSecond !== "" &&
          // 	res.data.zjtxProjectBO.tecFieldSecond !== null
          // ) {
          // 	this.jishu(res.data.zjtxProjectBO.tecFieldSecond, 2, 2);
          // }
          // if (
          // 	res.data.zjtxProjectBO.province !== "" &&
          // 	res.data.zjtxProjectBO.province !== null
          // ) {
          // 	this.quyu(res.data.zjtxProjectBO.province, 1, 2);
          // }
          // if (
          // 	res.data.zjtxProjectBO.city !== "" &&
          // 	res.data.zjtxProjectBO.city !== null
          // ) {
          // 	this.quyu(res.data.zjtxProjectBO.city, 2, 2);
          // }
          // this.param.zjtxProjectBO.zjtxType = "国家专精特新小巨人";
        }
        // if (this.param.zjtxListedInformationBO.isListed == 1) {
        // 	this.isshow1 = true;
        // 	this.isshow2 = false;
        // 	this.isshow3 = true;
        // } else if (this.param.zjtxListedInformationBO.isListed == 2) {
        // 	this.isshow1 = false;
        // 	this.isshow2 = true;
        // 	this.isshow3 = false;
        // } else if (this.param.zjtxListedInformationBO.isListed == 3) {
        // 	this.isshow1 = false;
        // 	this.isshow2 = false;
        // 	this.isshow3 = false;
        // }
      })
    },
    init() {
      //省
      getDistrictByParentId({ parentId: 0 }).then((res) => {
        this.province = res.data
      })
      //企业规模
      getDict({ type: 'zjtx_enterprise_scale' }).then((res) => {
        this.enterpriseScale = res.data
      })
      //是否上市
      getDict({ type: 'enterprise_is_market' }).then((res) => {
        this.enterpriseIsMarket = res.data
      })
      //上市类型
      getDict({ type: 'listing_type' }).then((res) => {
        this.listedType = res.data
      })

      //公司类型
      getDict({ type: 'company_type' }).then((res) => {
        this.companyTypes = res.data
      })
      //上市进程
      getDict({ type: 'listing_process' }).then((res) => {
        this.listedProcess = res.data
      })
      //技术领域一级
      getDict({ type: 'technical_field', parentId: 0 }).then((res) => {
        this.tecFieldFirst = res.data
      })

      let id = sessionStorage.getItem('zt_special_id')
      // console.log(id.length);
      if (id != undefined && id != null && id.length == 32) {
        this.queryInfo(id)
      } else {
        // this.qy();
        this.queryInfo('0')
      }
    },
    qy() {
      commonGetCompanyInfo().then((res) => {
        this.param.zjtxProjectBO = {
          companyName: res.data.name,
          unifySocialCreditCode: res.data.org_number,
          legalPerson: res.data.legal_person_name,
          industry: res.data.cate_3,
          registeredTime:
            new Date(res.data.approved_time).getFullYear() +
            '-' +
            (new Date(res.data.approved_time).getMonth() + 1 > 10
              ? new Date(res.data.approved_time).getMonth() + 1
              : '0' + (new Date(res.data.approved_time).getMonth() + 1)) +
            '-' +
            (new Date(res.data.approved_time).getDate() > 10
              ? new Date(res.data.approved_time).getDate()
              : '0' + new Date(res.data.approved_time).getDate()),
          registeredCapital: res.data.reg_capital,
          registeredType: res.data.company_org_type,
        }
        this.$nextTick(() => {
          this.$refs['ruleForm1'].clearValidate()
        })
      })
    },
    tecFieldCchange(val) {
      this.jishu(val, 1, 1)
    },
    tecFieldSecondCchange(val) {
      this.jishu(val, 2, 1)
    },
    // 技术领域
    jishu(val, type, stauts) {
      queryDictDataByTypeAndCode({ code: val, type: 'technical_field' }).then(
        (res) => {
          if (type == 1) {
            if (stauts == 1) {
              this.tecFieldThird = {}
              this.$set(this.param.zjtxProjectBO, 'tecFieldSecond', '')
              this.$set(this.param.zjtxProjectBO, 'tecFieldThird', '')
            }
            this.tecFieldSecond = res.data
          } else {
            if (stauts == 1) {
              this.$set(this.param.zjtxProjectBO, 'tecFieldThird', '')
            }
            this.tecFieldThird = res.data
          }
        }
      )
    },
    provinceCchange(val) {
      this.quyu(val, 1, 1)
    },
    cityCchange(val) {
      this.quyu(val, 2, 1)
    },
    // 区域
    quyu(val, type, stauts) {
      getDistrictByKey({ key: val }).then((res) => {
        if (type == 1) {
          if (stauts == 1) {
            this.counties = {}
            this.$set(this.param.zjtxProjectBO, 'city', '')
            this.$set(this.param.zjtxProjectBO, 'countie', '')
          }
          this.city = res.data
        } else {
          if (stauts == 1) {
            this.$set(this.param.zjtxProjectBO, 'countie', '')
          }
          this.counties = res.data
        }
      })
    },
    save() {
      let result1 = false;
      let result2 = false;
      let result3 = false;
      let result4 = false;
      this.param.zjtxProjectBO.zjtxType="国家专精特新小巨人";
      this.$refs['ruleForm1'].validate((valid) => {
        result1 = valid
      });
      this.$refs['ruleForm2'].validate((valid) => {
        result2 = valid
      });
      this.$refs['ruleForm3'].validate((valid) => {
        result3 = valid
      });
      this.$refs['ruleForm4'].validate((valid) => {
        result4 = valid
      });

      if (result1 && result2 && result3 && result4) {
        this.loading = true;
        // console.log(this.param);
        // console.log(this.param.zjtxProjectBO.id.length);
        if (this.param.zjtxProjectBO.id != undefined) {
          update_essential(this.param).then((res) => {
            this.loading = false
            if (res.code == '00000') {
              this.msgSuccess('修改成功')
            }
          })
        } else {
          add_essential(this.param).then((res) => {
            this.loading = false
            if (res.code == '00000') {
              this.msgSuccess('保存成功')
              sessionStorage.setItem('zt_special_id', res.data.projectInfo)
              this.param.zjtxProjectBO.id = res.data.projectInfo
              this.param.zjtxLinkmanBO.id = res.data.Linkman
              this.param.zjtxLegalPerson.id = res.data.LegalPerson
              this.param.zjtxListedInformationBO.id = res.data.ListedInformation
            }
          })
        }
      } else {
        this.msgError('数据不完整')
      }
    },
    handleClick(tab, event) {
      this.$confirm(
        '请确认当前页数据是否填写完整并保存,否则将导致数据丢失',
        '确认离开吗?',
        { type: 'warning' }
      )
        .then(() => {
          if (tab.index == 0) {
            this.$router.push('/centerform/specializationRegistration')
          } else {
            // console.log(sessionStorage.getItem("zt_special_id"));
            if (
              sessionStorage.getItem('zt_special_id') == undefined ||
              sessionStorage.getItem('zt_special_id') == null ||
              sessionStorage.getItem('zt_special_id').length != 32
            ) {
              // if (false){
              this.msgError('请先保存企业信息,保存后才可继续填写其它数据')
              this.activeName = 'first'
            } else {
              if (tab.index == 1) {
                this.$router.push('/centerform/specializationBenefit')
              } else if (tab.index == 2) {
                this.$router.push(
                  '/centerform/specializationProfessionalization'
                )
              } else if (tab.index == 3) {
                this.$router.push(
                  '/centerform/specializationInnovationCapacity'
                )
              } else if (tab.index == 4) {
                this.$router.push('/centerform/specializationManagement')
              } else if (tab.index == 5) {
                this.$router.push('/centerform/specializationDatagenerated')
              }
            }
          }
        })
        .catch((e) => {
          this.activeName = 'first'
        })
    },
  },
}
</script>

<style scoped>
.text {
  border-bottom: 1px solid #dbdbdb;
  position: relative;
  padding: 10px 20px;
}
.text::before {
  content: '';
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 12px;
  background: #7c99fd;
}
.ruleForm {
  width: 80%;
  margin-left: 10%;
}
.ruleForm .item {
  width: 50%;
}
.ruleForm .item .el-select,
.ruleForm .item .el-input,
.ruleForm .item .el-input-number,
.ruleForm .item .el-cascader {
  width: 70%;
}
.ruleForm .selects {
  width: 30% !important;
}
.iconfont {
  color: #d43030;
}
.wrap_page {
  margin-top: 20px;
}
</style>
